import {Theme, ThemeProvider, styled} from '@mui/material/styles'
import {useThemeMode} from '../../../../../_metronic/partials'
import {useEffect, useState} from 'react'
import {globalDarkMuiTheme, globalLightMuiTheme} from '../utility/globalMuiTheme'
import {CardContent} from '@mui/material'

const StyledCardContentThemed = styled(CardContent)(({theme}) => ({
  color: theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
}))

const StyledCardContent = (props) => {
  const {mode} = useThemeMode()
  const [muiTheme, setMuiTheme] = useState<Theme>(mode == 'light' ? globalLightMuiTheme : globalDarkMuiTheme)

  const handleUpdateTheme = () => {
    setMuiTheme((mode as any) == 'dark' ? globalDarkMuiTheme : globalLightMuiTheme)
  }

  useEffect(() => {
    handleUpdateTheme()
  }, [mode])

  return (
    <ThemeProvider theme={muiTheme}>
      <StyledCardContentThemed {...props} />
    </ThemeProvider>
  )
}

export default StyledCardContent
